import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ArticlesService } from '../../../services/articles.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-articles-detail',
    templateUrl: './articles-detail.component.html',
    styleUrls: ['./articles-detail.component.scss']
})
export class ArticlesDetailComponent implements OnInit {
    id: string = "0";

    pagecode: string = "article-detail";
    module: string = "articles";
    Menu: any[];
    pagetitle: string = "Single article";

    accessdenied: boolean = false;
    coverPhoto: string = "";
    article: any = {};

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router, private articlesService: ArticlesService, private authentication: AuthenticationService, private common: CommonService) { }

    ngOnInit(): void {

        let map: any = this.route.paramMap;
        this.id = map.destination._value.id;

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        //this.getAticlePost();
                        this.getArticleById();

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });




    }
   
    getArticleById() {
        this.articlesService.updateViewCount(this.id).subscribe(
            (res: any) => {
                //console.log("article res", res);
                if (res.success) {
                    if (res.data != null) {
                        this.article = res.data;
                        this.article.article = this.sanitizer.bypassSecurityTrustHtml(this.article.article);
                    }
                    else {
                        this.common.ShowMessage("error", "Error in loading the article", "");
                        console.error("Web/Articles/Detail", "data is null");
                    }
                }
                else {
                    this.common.ShowMessage("error", "Error in loading the article", "");
                    console.error("Web/Articles/Detail", res.error_message);
                }
            },
            (err: any) => {
                console.error("Web/Articles/Detail", err);
            }
        );


        //this.articlesService.getArticleById(this.id).subscribe(
        //  (res: any) => {
        //    if (res.success) {
        //      if (res.data != null) {
        //        this.article = res.data;
        //      }
        //      else {
        //        this.common.ShowMessage("error", "Error in loading the article", "");
        //        console.error("Web/Articles/Detail", "data is null");
        //      }
        //    }
        //    else {
        //      this.common.ShowMessage("error", "Error in loading the article", "");
        //      console.error("Web/Articles/Detail", res.error_message);
        //    }
        //  },
        //  (err: any) => {
        //    console.error("Web/Articles/Detail", err);
        //  }
        //);
    }

    

}
